// Creates a title if one has not already been created by the user, and then
// adds it to the chart data.
function addSaveTitle(data) {
  if (data.chart.data.slug) data.chart.title = data.chart.data.slug;
  else if (data.chart.data.dek.enabled) {
    data.chart.title = data.chart.data.dek.text;
  }
  return data;
}

// Makes charts data suitable for saving.
function getSaveData(activeDoc, userName) {
  let data = {
    // USER_ID is a window global.
    user: userName,
    _id: activeDoc.id,
    history: activeDoc.history,
    status: activeDoc.status,
    urls: activeDoc.urls,
    chart: activeDoc.chart.asMutable ? activeDoc.chart.asMutable({ deep: true }) : activeDoc.chart,
    product: activeDoc.chart.product,
  };
  data = addSaveTitle(data);
  return data;
}

function mergeRedux(doc, ...props) {
  const newData = doc.chart.data.merge([...props]);
  return doc.setIn(['chart', 'data'], newData);
}

export { getSaveData, addSaveTitle, mergeRedux };
